import React, { Component, createRef } from "react";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import validate from "../../common/validation";
import { Button, Card, CardBody, Container, Label, Row } from "reactstrap";
import { useHistory } from "react-router-dom";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { categoriTypes } from "components/StaticData";
import { addprocessedStocks, updateDataEntryStock } from "api";

class Cycle1VarifyAndAccept extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
      history: props.history,
      props: props?.location?.query,
      stockList: props?.location?.query.data.ds.stockDataEntryInWards,
      notEditableRows: props?.location?.query.data.ds.stockDataEntryInWards.map(
        x => x.id
      ),
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async componentDidMount() {
    console.log(this.state);
  }
  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    document.title = "grader flow";
    //meta title
    this.columns1 = [
      {
        dataField: "id",
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
        hidden: true,
        editable: false,
      },
      {
        dataField: "categories",
        text: "Categories",
        footer: "",
        editor: {
          type: Type.SELECT,
          options: this.categoriTypes,
        },
        editable: false,
        formatter: (cell, row1) => {
          return row1.category.name;
        },
      },
      {
        dataField: "weight",
        text: "inWard `${this.props.t('Weight / Carat')}`",
        type: "number",
        editable: false,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          return cell + " CT";
        },
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "weight", newValue, row, column),
      },
      {
        dataField: "outWardWeight",
        text: "outWard `${this.props.t('Weight / Carat')}`",
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2) + " CT",
        formatter: (cell, row, rowIndex) => {
          console.log(cell);
          return cell + " CT";
        },
        // editorRenderer: (
        //   editorProps,
        //   value,
        //   row,
        //   column,
        //   rowIndex,
        //   columnIndex
        // ) => {
        //   console.log(row.stockDataEntryInWard.outWardWeight)

        //   return <input type="number" onWheel={(e) => e.target.blur()} value={row.stockDataEntryInWard.outWardWeight} onChange={(e) => {row.stockDataEntryInWard.outWardWeight = parseInt(e.target.value)}}></input>;
        //   return value;
        // },
        // validator: (newValue, row, column) =>
        //   validate(
        //     [{ name: "number" }],
        //     "outWardWeight",
        //     newValue,
        //     row,
        //     column
        //   ),
      },
      {
        dataField: "pieces",
        text: "inWard Pieces",
        type: "number",
        editable: false,
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        validator: (newValue, row, column) =>
          validate([{ name: "number" }], "pieces", newValue, row, column),
      },
      {
        dataField: "outWardPieces",
        text: "outWardPieces",
        type: "number",
        footer: columnData =>
          columnData.reduce((acc, item) => acc + item, 0).toFixed(2),
        formatter: (cell, row, rowIndex) => {
          return cell;
        },
        validator: (newValue, row, column) =>
          validate(
            [{ name: "number" }],
            "outWardPieces",
            newValue,
            row,
            column
          ),
      },
      // {
      //   dataField: "boliman",
      //   text: "boli man",
      //   sort: true,
      //   editable: false,
      //   footer: "",
      //   formatter: (cell, row1) => {
      //     return row1.ftm.ms.mtg.user.name;
      //   },
      // },
      {
        dataField: "inward",
        text: `${this.props.t('Self Internal Remarks')}`,
        footer: "",
      },
      // {
      //   dataField: "edit",
      //   text: `${this.props.t('Edit Data')}`,
      //   footer: "",
      //   editable: true,

      //   editorRenderer: (
      //     editorProps,
      //     value,
      //     row,
      //     column,
      //     rowIndex,
      //     columnIndex
      //   ) => {
      //     return (
      //       <div className="btn-group">
      //         {!this.state.notEditableRows.includes(row.id) ? (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               this.setState({
      //                 notEditableRows: [...this.state.notEditableRows, row.id],
      //               });
      //             }}
      //           >
      //             <img src="images/dashboard-images/print.svg"></img>
      //           </span>
      //         ) : (
      //           <span
      //             className="border-0 rounded ms-2"
      //             onClick={() => {
      //               if (
      //                 this.state.notEditableRows.length ===
      //                 this.state.stockList.length
      //               )
      //                 this.setState({
      //                   notEditableRows: this.state.notEditableRows.filter(
      //                     x => x != row.id
      //                   ),
      //                 });
      //             }}
      //           >
      //             <img src="images/dashboard-images/edit.svg"></img>
      //           </span>
      //         )}
      //       </div>
      //     );
      //   },
      //   formatter: (cell, row, rowIndex) => (
      //     <div className="btn-group">
      //       {!this.state.notEditableRows.includes(row.id) ? (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             this.setState({
      //               notEditableRows: [...this.state.notEditableRows, row.id],
      //             });
      //           }}
      //         >
      //           <img src="images/dashboard-images/print.svg"></img>
      //         </span>
      //       ) : (
      //         <span
      //           className="border-0 rounded ms-2"
      //           onClick={() => {
      //             if (
      //               this.state.notEditableRows.length ===
      //               this.state.stockList.length
      //             )
      //               this.setState({
      //                 notEditableRows: this.state.notEditableRows.filter(
      //                   x => x != row.id
      //                 ),
      //               });
      //           }}
      //         >
      //           <img src="images/dashboard-images/edit.svg"></img>
      //         </span>
      //       )}
      //     </div>
      //   ),
      // },
    ];

    document.title = "add party";
    const { history } = this.props;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Cycle 1 - Verify & Accept " />
            <Card>
              <Formik
                enableReinitialize={true}
                initialValues={{
                  id: this.state.props.data.id,
                  partyCode: this.state.props.data.party.partyCode,
                  cycle:
                    Array.isArray(this.state.props.data.ds.gs.gtf) &&
                    this.state.props.data.ds.gs.gtf.length
                      ? this.state.props.data.ds.gs.gtf.reduce(
                          (prev, current) => {
                            return prev.cycle > current.cycle ? prev : current;
                          }
                        ).cycle
                      : 0,
                  graderNotes: this.state.props.data.graderNotes,
                }}
                validationSchema={Yup.object().shape({
                  id: Yup.string().required("This value is required"),
                  partyCode: Yup.string().required("This value is required"),
                  cycle: Yup.string().required("This value is required"),
                  graderNotes: Yup.string().nullable().notRequired(),
                })}
                onSubmit={async values => {
                  // Object.assign(values,{fillerStockId:this.state.props.data.id})

                  try {
                    if (this.state.props.isEdit == 1) {
                      delete values.partyCode;
                      delete values.cycle;
                      delete values.graderNotes;
                      delete values.id;
                      values.fillerStockId = this.state.props.data.id;
                      console.log(this.state.stockList)
                      if (Array.isArray(this.state.stockList) &&
                        this.state.stockList.filter(x => x.outWardWeight > 0)
                          .length ==
                          this.state.stockList.length &&
                        this.state.stockList.filter(x => x.outWardPieces > 0)
                          .length ==
                          this.state.stockList.length
                      ) {
                        console.log(
                          this.state.stockList
                        );
                        values.stockDataEntryInWards =
                        this.state.stockList;
                        // this.state.props.data.ds.stockDataEntryInWards.map(x => {
                        //   let temp = {};
                        //   temp.id = x.stockDataEntryInWard.id;
                        //   temp.dataEntryStockId =
                        //     x.stockDataEntryInWard.dataEntryStockId;
                        //   temp.outWardWeight = this.state.stockList.filter(
                        //     x =>
                        //       x.stockDataEntryInWard.id ==
                        //       x.stockDataEntryInWard.id
                        //   )[0].outWardWeight;
                        //   temp.outWardPieces = this.state.stockList.filter(
                        //     x =>
                        //       x.stockDataEntryInWard.id ==
                        //       x.stockDataEntryInWard.id
                        //   )[0].outWardPieces;

                        //   return temp;
                        // });
                        console.log(values);
                        values.jangadId = this.state.props.data.id;
                        values.id =
                          values.stockDataEntryInWards[0].dataEntryStockId;
                        delete values.fillerStockId;
                        await updateDataEntryStock(values);
                        history.goBack();
                      } else
                        alert("Please fill outWardPieces and outWardWeight");
                    }
                  } catch (err) {
                    console.log(err);
                  }
                  // history.push("/accepted-process-stock");
                }}
              >
                {({ errors, status, touched, values }) => (
                  <Form className="needs-validation">
                    <div className="pt-3">
                      <div className="row">
                        <div className="d-md-flex d-block justify-content-between px-4">
                          <div>
                            <h4 className="text-black fw-bold mb-4">
                              Cycle 1 - Verify & Accept
                            </h4>
                          </div>
                          {/* <div>
                            <label
                              htmlFor="date"
                              className="fs-4 pe-2 text-black fw-bold"
                            >
                              Verify & Accept Date:
                            </label>
                            <input type="date" className="fs-4 border-0" />
                          </div> */}
                        </div>

                        <CardBody>
                          <Row>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Jangad No')}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control form-select fs-5" +
                                    (errors.id && touched.id
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="id"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  <option value="id1">INWARD00187</option>
                                  <option value="id2">INWARD00187</option>
                                </Field>
                                <ErrorMessage
                                  name="id"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="partyCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Party Code')}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.partyCode && touched.partyCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="partyCode"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="partyCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            {/* <div className="mb-3 row">
                              <Label
                                htmlFor="boilMan"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  Boil Man Name
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.boilMan && touched.boilMan
                                      ? " is-invalid"
                                      : "")
                                  }
                                  name="boilMan"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  <option value="man1">Boil Man 1</option>
                                  <option value="man2">Boil Man 2</option>
                                </Field>
                                <ErrorMessage
                                  name="boilMan"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div> */}
                            <div className="mb-3 row">
                              <Label
                                htmlFor="cycle"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Cycle No.')}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.cycle && touched.cycle
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="cycle"
                                  placeholder="cycle 1"
                                />
                                <ErrorMessage
                                  name="cycle"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="graderNotes"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t('Grader Notes')}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.graderNotes && touched.graderNotes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  type="text"
                                  name="graderNotes"
                                  placeholder="Please Take of HPHT First Priority"
                                  as="textarea"
                                  rows="5"
                                />
                                <ErrorMessage
                                  name="graderNotes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                          </Row>
                        </CardBody>
                      </div>

                      <div className="row px-3 pt-3">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            To Verify & Accept Stock Details
                          </h3>
                        </div>
                        <div className="table-responsive">
                          <BootstrapTable
                            keyField="id"
                            classes="foo"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.state.stockList}
                            columns={this.columns1}
                            cellEdit={cellEditFactory({
                              mode: "click",
                              blurToSave: true,
                              // nonEditableRows: () => this.state.notEditableRows,
                              afterSaveCell:() => {
                                  this.setState({
                                    stockList: [...this.state.stockList]
                                  })
                                }
                            })}
                          />
                        </div>
                      </div>

                      <div className="row px-3 pt-4">
                        <div>
                          <h3 className="fw-bold pb-3 text-black">
                            To Verify & Accept Stock Details Summary
                          </h3>
                        </div>

                        <div className="table-responsive">
                          <BootstrapTable
                            classes="foo"
                            keyField="id"
                            headerClasses="background-light fs-5"
                            footerClasses="background-light fs-5"
                            bootstrap4={true}
                            data={this.state.stockList}
                            columns={this.columns1}
                          />
                        </div>
                      </div>
                      <div className="col-md-12 text-center text-md-end mt-4 pb-5 px-3">
                        <Button
                          color="white"
                          className="fs-4 px-5 text-primary me-4"
                          type="submit"
                        >
                          Accept
                        </Button>
                        <Link to={{
                          pathname:"/grader-reassign",
                          query: { isEdit: 1, data: this.state.props.data },
                          }}>
                        <Button
                          color="primary"
                          className="fs-4 px-5"
                          // onClick={() => history.push("/grader-reassign")}
                        >
                          Reject
                        </Button>
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(Cycle1VarifyAndAccept);
